import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Stick from '../../../es';
import Regression from './Regression';
const Anchor = ({ width }) => (_jsx("div", { style: {
        height: 15,
        width,
        backgroundColor: 'rgb(24, 170, 177)',
    } }));
const Node = ({ children }) => (_jsx("div", { style: {
        backgroundColor: '#ae0d5c',
        color: 'white',
    }, children: children }));
const Examples = ({ inline }) => (_jsxs("div", { style: {
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        height: 100,
        marginRight: 250,
    }, children: [_jsx(Stick, { inline: inline, position: "middle right", node: _jsx(Node, { children: "This text should stay on one line" }), children: _jsx(Anchor, { width: 15 }) }), _jsx(Stick, { inline: inline, position: "middle right", node: _jsx(Node, { children: "This text should stay on one line" }), children: _jsx(Anchor, { width: 150 }) }), _jsx("div", { style: { position: 'absolute', right: 150 }, children: _jsx(Stick, { inline: inline, position: "middle right", node: _jsx(Node, { children: "This text must line-break as it would reach off-screen otherwise. After we've increased page width, this text needed to be extended a bit." }), children: _jsx(Anchor, { width: 100 }) }) })] }));
export default function StickNodeWidth() {
    return (_jsxs(Regression, { allBrowsers: true, fixed: true, version: "1.0.0", title: "Stick node width", description: "The stick node should not line-break just because the anchor node is small. The stick node must only line-break if it would not fit onto the screen otherwise.", children: [_jsx(Examples, {}), _jsx("p", { children: "with `inline` prop:" }), _jsx(Examples, { inline: true })] }));
}
